import { useCallback, useState } from 'react';

export function useOpenClose(open: boolean = false) {
  const [state, setState] = useState(open);
  const onOpen = useCallback(() => setState(true), []);
  const onClose = useCallback(() => setState(false), []);
  return [state, onOpen, onClose] as const;
}
